<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9aNfks/tc-custom/9780226676319.jpg?1722568555932" alt="This image is the cover for the book People of Plenty"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">People of Plenty
      </h1>
      <p class="bookDescription body article font2">
        <p>America has long been famous as a land of plenty, but we seldom realize how much the American people are a <i>people of plenty</i>—a people whose distinctive character has been shaped by economic abundance. In this important book, David M. Potter breaks new ground both in the study of this phenomenon and in his approach to the question of national character. He brings a fresh historical perspective to bear on the vital work done in this field by anthropologists, social psychologists, and psychoanalysts.<br/><br/> "The rejection of hindsight, with the insistence on trying to see events from the point of view of the participants, was a governing theme with Potter. . . . This sounds like a truism. Watching him apply it however, is a revelation."—Walter Clemons, <i>Newsweek</i><br/><br/> "The best short book on national character I have seen . . . broadly based, closely reasoned, and lucidly written."—Karl W. Deutsch, <i>Yale Review<br/><br/></i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David M. Potter
      </h2>
      
      <p class="authorDescription body article"><B>David M. Potter</B> (1910-1971)&#160;was a professor of history at Yale University and,&#160;at the time of his death,&#160;Coe Professor of American History at Stanford University.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cfc04dc2